/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useState, useMemo, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import localforage from "localforage";
import { useAppServices } from "../hook/services";

// Material Dashboard 2 React main context
const WhiteLabelContext = createContext();

// Setting custom name for the context which is visible on react dev tools
WhiteLabelContext.displayName = "WhiteLabelContext";

// Material Dashboard 2 React context provider
function WhiteLabelProvider({ children }) {
  const Service = useAppServices();
  const [WhiteLabel, setWhiteLabel] = useState({});
  const [loader, setLoader] = useState(true);

  const Update = (updates) => {
    const data = { ...WhiteLabel, ...updates };
    setWhiteLabel(data);
  };

  const clear = () => setWhiteLabel({});

  const value = useMemo(
    () => [WhiteLabel, Update, clear],
    [WhiteLabel, Update, clear]
  );

  const chnageTitleAndFavicon = async (title,favicon) => {
if (title) document.title = title;

    if (favicon) {
      const icon = document.querySelector("link[rel='icon']");
      icon.href = favicon;
    }
  }

  const getWhiteLabel = async () => {
    const { response } = await Service.knowledgebase_customization.filter({
      query: `domain=${window.location.hostname}`,
    });
    if (!response) return setLoader(false);

    chnageTitleAndFavicon(response.data?.companyName || "knowledgebase",response.data?.logo)
    setWhiteLabel({ ...response.data });
    localStorage.setItem("WhiteLabel", { ...response.data });
    return setLoader(false);
  };

  let pageLoad = true;
  const onLoad = () => {
    if (pageLoad) {
      getWhiteLabel();
      pageLoad = false;
    }
  };

  useEffect(onLoad, []);

  return loader ? (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        background: "#fafafa",
        zIndex: 9999,
      }}
    >
      <style>{`
        @keyframes wl-spin { to { transform: rotate(360deg); } }
      `}</style>
      <div
        style={{
          width: "44px",
          height: "44px",
          borderRadius: "50%",
          border: "4px solid #e2e8f0",
          borderTopColor: "#2563eb",
          animation: "wl-spin 0.8s linear infinite",
        }}
      />
      <div style={{ textAlign: "center" }}>
        <div
          style={{ fontSize: "14px", fontWeight: 600, color: "#0f172a" }}
        >
          Loading knowledgebase…
        </div>
        <div style={{ fontSize: "12.5px", color: "#64748b", marginTop: "4px" }}>
          Please wait a moment
        </div>
      </div>
    </div>
  ) : (
    <WhiteLabelContext.Provider value={value}>
      {children}
    </WhiteLabelContext.Provider>
  );
}

// Material Dashboard 2 React custom hook for using context
function useWhiteLabelInfo() {
  return useContext(WhiteLabelContext) || [];
}

// Typechecking props for the MaterialUIControllerProvider
WhiteLabelProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { WhiteLabelProvider, useWhiteLabelInfo };
